// Wrap-around prev/next + ←/→ keyboard handling for a lightbox. Pure
// index arithmetic on top of the caller's openIndex state so PhotoGallery
// and the postventa observation detail share one navigation contract.

import { useCallback } from "react";
import type { KeyboardEvent } from "react";

export function useLightboxNav(
  count: number,
  openIndex: number | null,
  setOpenIndex: (i: number) => void
) {
  const step = useCallback(
    (delta: number) => {
      if (openIndex === null || count === 0) return;
      setOpenIndex((openIndex + delta + count) % count);
    },
    [count, openIndex, setOpenIndex]
  );

  const prev = useCallback(() => step(-1), [step]);
  const next = useCallback(() => step(1), [step]);

  const onKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (count < 2) return;
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        step(-1);
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        step(1);
      }
    },
    [count, step]
  );

  return { prev, next, onKeyDown };
}
